// Ported verbatim from the Claude Design prototype ("Zenya Sitio Web.dc.html").
// Placeholder photo captions (fotos/slides) are intentional -- see PhotoPlaceholder.
export const CATS = [
  {
    id: 'masajes',
    nombre: 'Masajes',
    cta: 'Ver masajes',
    desc: 'Descontracturante, relajante o con piedras calientes. Cabinas privadas, presión ajustada a lo que tu cuerpo necesita ese día.',
    intro:
      'Trabajamos con presión adaptada, aceites tibios y cabinas privadas. Antes de empezar preguntamos qué te duele y qué esperas de la sesión.',
    fotos: ['Cabina de masaje', 'Aceites y aromaterapia', 'Camilla y textiles', 'Detalle de manos'],
    slides: [
      'Cabina en penumbra',
      'Masaje de espalda',
      'Piedras calientes',
      'Aceites esenciales',
      'Detalle de toallas',
    ],
  },
  {
    id: 'faciales',
    nombre: 'Faciales',
    cta: 'Ver faciales',
    desc: 'Limpieza profunda, hidratación y tratamientos antiedad con producto profesional y diagnóstico previo de tu piel.',
    intro:
      'Cada facial empieza con una revisión de tu piel. De ahí decidimos activos, intensidad y frecuencia. Sin promesas imposibles.',
    fotos: ['Cabina facial', 'Producto profesional', 'Vaporizador', 'Piel después del facial'],
    slides: [
      'Cabina facial',
      'Mascarilla en aplicación',
      'Producto y ampolletas',
      'Limpieza con vapor',
      'Piel al terminar',
    ],
  },
  {
    id: 'unas',
    nombre: 'Uñas',
    cta: 'Ver uñas',
    desc: 'Manicure ruso, semipermanente, acrílico, gel y pedicure spa. Material esterilizado y acabado que dura.',
    intro:
      'Manicure ruso como base de todo: cutícula limpia, uña pareja y esmaltado que no se levanta a los tres días.',
    fotos: ['Estación de manicure', 'Uñas terminadas', 'Paleta de colores', 'Pedicure spa'],
    slides: [
      'Manicure ruso en proceso',
      'Uñas nude terminadas',
      'Nail art a mano',
      'Estación de pedicure',
      'Paleta de esmaltes',
    ],
  },
  {
    id: 'pestanas',
    nombre: 'Pestañas',
    cta: 'Ver pestañas',
    desc: 'Extensiones clásicas, volumen ruso, lifting y diseño de cejas. Mapeo según tu mirada, no un molde igual para todas.',
    intro:
      'Diseñamos el mapeo según la forma de tu ojo y la pestaña natural que tienes. Duración real, sin sobrecargar.',
    fotos: ['Área de pestañas', 'Mapeo de diseño', 'Antes y después', 'Detalle de mirada'],
    slides: [
      'Área de pestañas',
      'Aplicación pelo a pelo',
      'Volumen ruso terminado',
      'Lifting antes y después',
      'Diseño de cejas',
    ],
  },
];

export const TRAT = {
  masajes: [
    {
      id: 'relajante',
      nombre: 'Masaje relajante',
      duracion: '60 min',
      precio: '$650',
      etiqueta: 'Presión suave',
      resumen: 'Presión suave y ritmo constante para bajar el nivel de estrés y soltar el cuerpo completo.',
      descripcion:
        'Un masaje de cuerpo completo con maniobras largas y presión ligera a media. No busca deshacer contracturas profundas: busca que el sistema nervioso baje una marcha. Usamos aceite tibio y aromaterapia suave; la cabina se mantiene en penumbra y con música baja durante toda la sesión.',
      video: 'Recorrido de 40 segundos por la cabina y las maniobras iniciales',
      beneficios: [
        'Reduce la sensación de estrés y tensión acumulada',
        'Mejora la calidad del sueño esa misma noche',
        'Activa la circulación sin dejar el cuerpo adolorido',
        'Alivia rigidez ligera de cuello y hombros',
      ],
      procedimiento: [
        'Breve charla para saber cómo llegas y qué zonas evitar',
        'Preparación de la cabina, aceite tibio y aromaterapia a elegir',
        'Maniobras de espalda, piernas, brazos, cuello y cuero cabelludo',
        'Cierre con presión ligera y unos minutos de reposo con agua',
      ],
      ideal: 'Semanas pesadas, insomnio ligero, primera vez en masaje o si prefieres presión suave.',
      fotos: ['Cabina lista', 'Aceites tibios', 'Maniobra de espalda', 'Detalle de textiles'],
      faq: [
        { p: '¿Cuánto dura?', r: '60 minutos de masaje. Considera 15 minutos extra entre la llegada y el cierre.' },
        {
          p: '¿Qué debo hacer antes de mi cita?',
          r: 'Llega 10 minutos antes y evita comidas pesadas la hora previa. No necesitas traer nada.',
        },
        {
          p: '¿Tiene contraindicaciones?',
          r: 'No se recomienda con fiebre, infecciones de piel activas, trombosis o cirugía reciente. En embarazo avisa al agendar para adaptar la posición.',
        },
        {
          p: '¿Cada cuánto se recomienda?',
          r: 'Una vez al mes para mantenimiento; cada quince días si tienes mucha carga de estrés.',
        },
      ],
    },
    {
      id: 'descontracturante',
      nombre: 'Masaje descontracturante',
      duracion: '60 min',
      precio: '$750',
      etiqueta: 'Presión profunda',
      resumen: 'Trabajo focalizado en espalda, cuello y hombros para liberar nudos y dolor por postura.',
      descripcion:
        'Presión profunda y sostenida sobre puntos de tensión concretos. Está pensado para quien pasa horas frente a la computadora, carga peso o duerme en mala posición. Localizamos las bandas tensas y trabajamos con fricción, amasamiento y estiramientos asistidos. Puede ser incómodo en momentos puntuales, nunca doloroso: ajustamos la presión durante toda la sesión.',
      video: 'Explicación de la fundadora sobre cómo se localiza y trabaja una contractura',
      beneficios: [
        'Libera contracturas de cuello, trapecio y zona lumbar',
        'Mejora el rango de movimiento del hombro',
        'Reduce dolores de cabeza de origen tensional',
        'Corrige molestias por postura de escritorio',
      ],
      procedimiento: [
        'Revisión de zonas de dolor y nivel de presión que toleras',
        'Calentamiento del tejido con maniobras superficiales',
        'Trabajo profundo por puntos gatillo y bandas tensas',
        'Estiramientos asistidos y recomendaciones para casa',
      ],
      ideal: 'Dolor de cuello y espalda por trabajo de escritorio, cargas físicas o entrenamiento intenso.',
      fotos: ['Trabajo en trapecio', 'Detalle de antebrazo', 'Camilla y postura', 'Estiramiento asistido'],
      faq: [
        {
          p: '¿Duele?',
          r: 'Se siente intenso en los puntos de contractura, pero la presión se ajusta en todo momento. Si duele, se baja.',
        },
        {
          p: '¿Qué debo hacer antes de mi cita?',
          r: 'Hidrátate bien el día anterior y avisa si tomas anticoagulantes o tienes alguna lesión reciente.',
        },
        {
          p: '¿Qué cuidados necesito después?',
          r: 'Toma agua, evita entrenamiento fuerte las siguientes 12 horas. Es normal sentir la zona sensible un día.',
        },
        { p: '¿Cada cuánto se recomienda?', r: 'Cada 15 días mientras la contractura cede; después una vez al mes.' },
      ],
    },
    {
      id: 'piedras',
      nombre: 'Masaje con piedras calientes',
      duracion: '75 min',
      precio: '$890',
      etiqueta: 'Termoterapia',
      resumen:
        'Calor de piedras volcánicas combinado con maniobras suaves para relajar músculo profundo sin presión fuerte.',
      descripcion:
        'Las piedras de basalto se calientan a temperatura controlada y se colocan sobre puntos clave de la espalda mientras se trabaja el resto del cuerpo. El calor abre el tejido y permite llegar a capas profundas con mucha menos presión. Es el masaje más envolvente del menú y el favorito de quien siente frío o tiene tensión difusa.',
      video: 'Preparación de las piedras y colocación sobre la espalda',
      beneficios: [
        'Relaja músculo profundo sin presión intensa',
        'Mejora circulación por efecto del calor',
        'Alivia rigidez generalizada y sensación de frío',
        'Efecto sedante que ayuda a dormir mejor',
      ],
      procedimiento: [
        'Calentamiento y verificación de temperatura de las piedras',
        'Colocación estática sobre espalda y palmas',
        'Maniobras con piedra en movimiento sobre todo el cuerpo',
        'Retiro, aceite de cierre y reposo breve',
      ],
      ideal: 'Tensión difusa, mala circulación, o si quieres una experiencia más envolvente que un masaje estándar.',
      fotos: ['Piedras en calentador', 'Colocación en espalda', 'Detalle de piedra en mano', 'Cabina completa'],
      faq: [
        {
          p: '¿Qué tan calientes están las piedras?',
          r: 'Entre 50 y 55 °C, verificadas antes de cada contacto. Si sientes demasiado calor lo ajustamos al instante.',
        },
        {
          p: '¿Tiene contraindicaciones?',
          r: 'No se recomienda en embarazo, diabetes con neuropatía, hipertensión no controlada o problemas de sensibilidad térmica.',
        },
        { p: '¿Qué incluye?', r: '75 minutos de masaje de cuerpo completo con piedras, aceite y aromaterapia.' },
        { p: '¿Cada cuánto se recomienda?', r: 'Una vez al mes es suficiente para sostener el efecto.' },
      ],
    },
    {
      id: 'linfatico',
      nombre: 'Drenaje linfático',
      duracion: '60 min',
      precio: '$800',
      etiqueta: 'Descongestivo',
      resumen: 'Maniobras muy suaves y rítmicas para reducir retención de líquidos e inflamación.',
      descripcion:
        'Técnica manual de presión ligera que sigue el recorrido del sistema linfático para movilizar líquido retenido. Se siente casi como un roce y no busca trabajar músculo. Es común después de cirugías estéticas, en piernas hinchadas o en procesos de inflamación por sedentarismo. Requiere constancia: una sesión aislada da alivio, la serie da resultado.',
      video: 'Demostración del sentido y ritmo de las maniobras en pierna',
      beneficios: [
        'Disminuye hinchazón de piernas, abdomen y brazos',
        'Ayuda a la recuperación posquirúrgica',
        'Mejora la sensación de pesadez al final del día',
        'Favorece la eliminación de líquidos retenidos',
      ],
      procedimiento: [
        'Valoración de zonas con retención',
        'Apertura de ganglios en cuello, axilas e ingles',
        'Maniobras rítmicas y suaves en dirección al drenaje',
        'Recomendaciones de hidratación y movimiento',
      ],
      ideal: 'Retención de líquidos, piernas cansadas, posoperatorio autorizado por tu médico.',
      fotos: ['Maniobra en pierna', 'Detalle de manos', 'Camilla elevada', 'Toallas y agua'],
      faq: [
        {
          p: '¿Cuántas sesiones necesito?',
          r: 'Para un objetivo concreto, entre 6 y 10 sesiones. Para mantenimiento, una o dos al mes.',
        },
        {
          p: '¿Tiene contraindicaciones?',
          r: 'No se realiza con infección activa, insuficiencia cardiaca o renal descompensada, ni trombosis. En posoperatorio necesitamos el visto bueno de tu médico.',
        },
        {
          p: '¿Qué cuidados necesito después?',
          r: 'Toma bastante agua y camina un poco. Evita sal en exceso ese día.',
        },
        { p: '¿Es doloroso?', r: 'No. Es de los tratamientos más suaves del menú.' },
      ],
    },
  ],
  faciales: [
    {
      id: 'limpieza',
      nombre: 'Limpieza facial profunda',
      duracion: '60 min',
      precio: '$750',
      etiqueta: 'Base de todo',
      resumen: 'Higiene completa con extracción, vapor y mascarilla según tu tipo de piel.',
      descripcion:
        'El punto de partida para cualquier rutina. Desincrusta poros, retira células muertas y deja la piel lista para absorber producto. Incluye diagnóstico previo, doble limpieza, exfoliación, vapor, extracción manual controlada, alta frecuencia si hace falta y mascarilla ajustada a tu piel. Terminamos con hidratación y protector solar.',
      video: 'Los cinco pasos de la limpieza, explicados en un minuto',
      beneficios: [
        'Poros visiblemente más limpios y cerrados',
        'Menos puntos negros y textura irregular',
        'Mejor absorción de tus productos en casa',
        'Piel más luminosa desde la primera sesión',
      ],
      procedimiento: [
        'Diagnóstico de piel y desmaquillado',
        'Exfoliación y vapor para abrir poro',
        'Extracción manual y alta frecuencia',
        'Mascarilla, hidratación y protector solar',
      ],
      ideal: 'Piel con puntos negros, poro abierto, textura irregular o quien nunca se ha hecho un facial.',
      fotos: ['Cabina facial', 'Vaporizador en uso', 'Mascarilla aplicada', 'Piel al terminar'],
      faq: [
        { p: '¿Cuánto dura?', r: '60 minutos.' },
        {
          p: '¿Qué debo hacer antes de mi cita?',
          r: 'Llega sin maquillaje si puedes, y suspende exfoliantes o retinol tres días antes.',
        },
        {
          p: '¿Qué cuidados necesito después?',
          r: 'Protector solar estricto, nada de exfoliar ni maquillarte las siguientes 24 horas.',
        },
        { p: '¿Cada cuánto se recomienda?', r: 'Cada 4 a 6 semanas.' },
      ],
    },
    {
      id: 'hidratante',
      nombre: 'Facial hidratante',
      duracion: '50 min',
      precio: '$650',
      etiqueta: 'Sin extracción',
      resumen: 'Aporte intensivo de agua y activos para piel seca, tirante o apagada.',
      descripcion:
        'Facial sin extracción, enfocado en devolver agua y lípidos a la piel. Trabajamos con ácido hialurónico, ampolletas y mascarilla oclusiva, más un masaje facial de drenaje que desinflama la mirada. Es el más cómodo del menú y el que mejor funciona antes de un evento.',
      video: 'Masaje facial de drenaje paso a paso',
      beneficios: [
        'Piel suave y con luz inmediata',
        'Reduce tirantez y descamación',
        'Desinflama la zona de ojos',
        'Sin enrojecimiento: sirve antes de un evento',
      ],
      procedimiento: [
        'Doble limpieza y tónico',
        'Exfoliación enzimática suave',
        'Ampolleta de activos y masaje de drenaje',
        'Mascarilla hidratante, sellado y protector',
      ],
      ideal:
        'Piel seca, apagada, deshidratada por clima o aire acondicionado. Perfecto días antes de una boda o evento.',
      fotos: ['Ampolletas y sérum', 'Masaje facial', 'Mascarilla oclusiva', 'Detalle de piel'],
      faq: [
        { p: '¿Deja la piel roja?', r: 'No. Puedes salir maquillada el mismo día.' },
        {
          p: '¿Qué incluye?',
          r: 'Limpieza, exfoliación enzimática, ampolleta, masaje, mascarilla e hidratación final.',
        },
        { p: '¿Cada cuánto se recomienda?', r: 'Cada tres o cuatro semanas, o antes de eventos importantes.' },
        { p: '¿Sirve para piel grasa?', r: 'Sí. La piel grasa también se deshidrata; ajustamos los activos.' },
      ],
    },
    {
      id: 'antiedad',
      nombre: 'Facial antiedad',
      duracion: '75 min',
      precio: '$1,100',
      etiqueta: 'Premium',
      resumen: 'Protocolo de firmeza con activos concentrados y masaje de tonificación.',
      descripcion:
        'Sesión enfocada en firmeza, líneas finas y pérdida de definición del óvalo facial. Combina exfoliación con ácidos suaves, un cóctel de péptidos y vitamina C, masaje de tonificación muscular y mascarilla de efecto tensor. Los resultados se acumulan: se nota desde la primera, se sostiene con serie.',
      video: 'Antes y después de una serie de cuatro sesiones',
      beneficios: [
        'Mejora firmeza y definición del óvalo',
        'Atenúa líneas de expresión finas',
        'Unifica tono y reduce manchas leves',
        'Estimula producción de colágeno',
      ],
      procedimiento: [
        'Diagnóstico y limpieza profunda',
        'Exfoliación con ácidos suaves',
        'Cóctel de péptidos, vitamina C y masaje tonificante',
        'Mascarilla tensora, contorno de ojos y protector',
      ],
      ideal: 'Piel de 35 años en adelante, o antes si hay pérdida de firmeza y daño solar.',
      fotos: ['Producto antiedad', 'Masaje de tonificación', 'Mascarilla tensora', 'Resultado de piel'],
      faq: [
        {
          p: '¿Cuántas sesiones para ver resultado?',
          r: 'Una serie de cuatro sesiones, una por semana, y luego mantenimiento mensual.',
        },
        {
          p: '¿Tiene contraindicaciones?',
          r: 'No se aplica sobre rosácea activa, heridas o tratamientos con isotretinoína recientes.',
        },
        {
          p: '¿Qué cuidados necesito después?',
          r: 'Protector solar diario sin excepción y evitar exposición directa 48 horas.',
        },
        {
          p: '¿Se puede combinar con otros tratamientos?',
          r: 'Sí, alternando con limpiezas profundas cada seis semanas.',
        },
      ],
    },
    {
      id: 'purificante',
      nombre: 'Facial purificante',
      duracion: '60 min',
      precio: '$800',
      etiqueta: 'Piel grasa',
      resumen: 'Control de grasa y brotes con activos seborreguladores y alta frecuencia.',
      descripcion:
        'Diseñado para piel grasa o con acné leve a moderado. Regula sebo, desinflama y reduce brotes sin resecar. Usamos ácido salicílico, niacinamida y alta frecuencia para el efecto bactericida. No sustituye el tratamiento dermatológico en acné severo, pero mejora mucho el estado de la piel entre consultas.',
      video: 'Cómo funciona la alta frecuencia sobre un brote',
      beneficios: [
        'Reduce brotes y enrojecimiento',
        'Controla producción de grasa durante semanas',
        'Desinflama lesiones activas',
        'Mejora la textura sin resecar',
      ],
      procedimiento: [
        'Diagnóstico y doble limpieza con activo salicílico',
        'Vapor y extracción de comedones',
        'Alta frecuencia sobre lesiones activas',
        'Mascarilla de arcilla, hidratación ligera y protector',
      ],
      ideal: 'Piel grasa, acné leve o moderado, brotes hormonales recurrentes.',
      fotos: ['Alta frecuencia', 'Mascarilla de arcilla', 'Producto seborregulador', 'Detalle de piel'],
      faq: [
        {
          p: '¿Sirve para acné severo?',
          r: 'Complementa, pero no sustituye el tratamiento con dermatólogo. Te lo diremos con honestidad en el diagnóstico.',
        },
        {
          p: '¿Qué debo hacer antes de mi cita?',
          r: 'Suspende retinol y exfoliantes cinco días antes. No revientes lesiones.',
        },
        {
          p: '¿Qué cuidados necesito después?',
          r: 'Nada de maquillaje 24 horas, protector solar libre de aceite y no tocar la cara.',
        },
        { p: '¿Cada cuánto se recomienda?', r: 'Cada tres semanas mientras se controla el brote.' },
      ],
    },
  ],
  unas: [
    {
      id: 'manicure-ruso',
      nombre: 'Manicure ruso con semipermanente',
      duracion: '75 min',
      precio: '$450',
      etiqueta: 'Más solicitado',
      resumen: 'Cutícula trabajada con torno, uña pareja y esmaltado que dura tres semanas sin levantarse.',
      descripcion:
        'La técnica rusa trabaja la cutícula en seco con torno, lo que permite esmaltar más cerca del nacimiento de la uña. El resultado se ve más limpio y crece de forma más discreta. Incluye limado a la forma que elijas, tratamiento de cutícula, esmaltado semipermanente en el color de tu elección y aceite final.',
      video: 'Detalle del trabajo de cutícula con torno',
      beneficios: [
        'Dura tres semanas o más sin levantarse',
        'Acabado más limpio en la base de la uña',
        'Crecimiento menos visible',
        'Cutícula sana y sin cortes agresivos',
      ],
      procedimiento: [
        'Retiro de esmalte anterior y revisión de la uña natural',
        'Trabajo de cutícula en seco con torno',
        'Limado y forma a elección',
        'Esmaltado semipermanente en capas finas y curado',
      ],
      ideal: 'Quien quiere manos impecables con mantenimiento cada tres semanas.',
      fotos: ['Estación de manicure', 'Trabajo con torno', 'Esmaltado en capas', 'Resultado final'],
      faq: [
        { p: '¿Cuánto dura?', r: '75 minutos el servicio; el esmaltado dura de 3 a 4 semanas.' },
        {
          p: '¿Daña la uña?',
          r: 'No, si el retiro se hace correctamente. Nunca despegamos con fuerza: se retira con limado controlado.',
        },
        {
          p: '¿Qué debo hacer antes de mi cita?',
          r: 'Llega sin crema en las manos y, si traes esmaltado de otro lugar, avísanos al agendar.',
        },
        { p: '¿Cada cuánto se recomienda?', r: 'Cada 3 semanas para mantenimiento.' },
      ],
    },
    {
      id: 'acrilico',
      nombre: 'Uñas acrílicas',
      duracion: '120 min',
      precio: '$700',
      etiqueta: 'Juego nuevo',
      resumen: 'Extensión con acrílico, forma y largo a elección, con acabado esculpido a mano.',
      descripcion:
        'Construcción completa de uña con acrílico sobre tip o molde. Elegimos juntas forma y largo según tu mano y tu día a día. El acabado se esculpe a mano para que el grosor quede parejo y natural, no como una placa. Incluye esmaltado semipermanente de color liso; el nail art se cotiza aparte.',
      video: 'Esculpido de una uña de principio a fin',
      beneficios: [
        'Largo y forma personalizados',
        'Resistencia alta para uso diario',
        'Corrige uñas mordidas o desiguales',
        'Base estable para nail art elaborado',
      ],
      procedimiento: [
        'Preparación de la uña natural y elección de forma',
        'Colocación de tip o molde',
        'Aplicación y esculpido del acrílico',
        'Limado, pulido y esmaltado semipermanente',
      ],
      ideal: 'Uñas cortas o mordidas, eventos, o quien quiere largo y resistencia.',
      fotos: ['Esculpido en proceso', 'Formas disponibles', 'Juego terminado', 'Detalle de grosor'],
      faq: [
        { p: '¿Cada cuánto necesito relleno?', r: 'Cada 3 a 4 semanas, según el crecimiento de tu uña.' },
        { p: '¿Qué incluye?', r: 'Preparación, extensión, esculpido y esmaltado liso. El diseño se cobra aparte.' },
        {
          p: '¿Qué cuidados necesito después?',
          r: 'Usa guantes para limpiar, no las uses como herramienta y aplica aceite de cutícula a diario.',
        },
        {
          p: '¿Se pueden retirar en casa?',
          r: 'No. El retiro casero es lo que más daña la uña natural; hazlo con nosotras.',
        },
      ],
    },
    {
      id: 'gel',
      nombre: 'Recubrimiento de gel',
      duracion: '90 min',
      precio: '$600',
      etiqueta: 'Natural',
      resumen: 'Refuerzo con gel constructor sobre tu uña natural, sin extensión.',
      descripcion:
        'Para quien quiere fuerza sin largo. El gel constructor se aplica sobre la uña natural para reforzarla y darle una curva pareja. Es más flexible y ligero que el acrílico, y permite que la uña crezca protegida. Excelente opción si tus uñas se quiebran con facilidad.',
      video: 'Diferencia entre gel y acrílico, explicada en la mano',
      beneficios: [
        'Refuerza uñas débiles o quebradizas',
        'Acabado ligero y flexible',
        'Permite que la uña natural crezca protegida',
        'Aspecto muy natural',
      ],
      procedimiento: [
        'Manicure ruso de preparación',
        'Aplicación de base y gel constructor',
        'Curado en lámpara y limado de forma',
        'Esmaltado semipermanente y aceite final',
      ],
      ideal: 'Uñas que se quiebran, quien no quiere largo pero sí durabilidad.',
      fotos: ['Aplicación de gel', 'Curado en lámpara', 'Acabado natural', 'Comparativa antes y después'],
      faq: [
        { p: '¿Cuánto dura?', r: 'De 3 a 4 semanas con relleno.' },
        {
          p: '¿Es lo mismo que semipermanente?',
          r: 'No. El semipermanente es color; el gel constructor es estructura y refuerzo.',
        },
        { p: '¿Cada cuánto se recomienda?', r: 'Relleno cada 3 o 4 semanas.' },
        { p: '¿Qué cuidados necesito después?', r: 'Aceite de cutícula diario y evitar usarlas para abrir cosas.' },
      ],
    },
    {
      id: 'pedicure',
      nombre: 'Pedicure spa',
      duracion: '60 min',
      precio: '$450',
      etiqueta: 'Con masaje',
      resumen: 'Remojo, exfoliación, trabajo de talón y esmaltado, con masaje de pies incluido.',
      descripcion:
        'Un pedicure completo, no solo esmaltado. Incluye remojo en sales, corte y limado, trabajo de cutícula, retiro de callosidad en talones, exfoliación con sal, mascarilla, masaje de pies y pantorrilla y esmaltado normal o semipermanente. La silla es cómoda y el servicio dura lo que tiene que durar.',
      video: 'Recorrido por la estación de pedicure',
      beneficios: [
        'Elimina callosidad y talón agrietado',
        'Pies suaves durante semanas',
        'Masaje que descansa piernas cansadas',
        'Esmaltado parejo y duradero',
      ],
      procedimiento: [
        'Remojo en sales tibias',
        'Corte, limado y trabajo de cutícula',
        'Retiro de callosidad y exfoliación',
        'Mascarilla, masaje y esmaltado',
      ],
      ideal: 'Talones resecos, pies cansados, mantenimiento mensual.',
      fotos: ['Estación de pedicure', 'Remojo en sales', 'Exfoliación', 'Resultado final'],
      faq: [
        {
          p: '¿Incluye semipermanente?',
          r: 'El esmalte normal está incluido. El semipermanente tiene un costo adicional de $120.',
        },
        {
          p: '¿Tiene contraindicaciones?',
          r: 'Con diabetes trabajamos sin instrumento cortante; avísanos al agendar. No se realiza con hongos activos o heridas abiertas.',
        },
        { p: '¿Cada cuánto se recomienda?', r: 'Cada 4 semanas.' },
        { p: '¿Cuánto dura?', r: '60 minutos.' },
      ],
    },
  ],
  pestanas: [
    {
      id: 'clasicas',
      nombre: 'Extensiones clásicas',
      duracion: '120 min',
      precio: '$700',
      etiqueta: 'Efecto natural',
      resumen: 'Una extensión por pestaña natural. Mirada definida sin que se note postiza.',
      descripcion:
        'Técnica pelo a pelo: una extensión por cada pestaña natural, respetando su grosor y su ciclo de crecimiento. El resultado es una mirada más definida y despierta, como si tuvieras rímel puesto todo el tiempo. Antes de aplicar diseñamos el mapeo según la forma de tu ojo.',
      video: 'Aplicación pelo a pelo vista de cerca',
      beneficios: [
        'Mirada definida sin maquillaje diario',
        'Aspecto natural, nadie nota que son extensiones',
        'Respeta el ciclo de tu pestaña natural',
        'Ahorra tiempo cada mañana',
      ],
      procedimiento: [
        'Limpieza de pestañas y mapeo del diseño',
        'Aislamiento pestaña por pestaña',
        'Aplicación de la extensión con adhesivo profesional',
        'Sellado, secado y revisión final',
      ],
      ideal: 'Primera vez en extensiones o quien prefiere un resultado discreto.',
      fotos: ['Área de pestañas', 'Mapeo de diseño', 'Aplicación en proceso', 'Resultado final'],
      faq: [
        { p: '¿Cuánto duran?', r: 'Se ven completas de 2 a 3 semanas. El relleno se recomienda cada 3 semanas.' },
        {
          p: '¿Qué debo hacer antes de mi cita?',
          r: 'Llega sin maquillaje de ojos y sin rímel a prueba de agua. Evita cremas grasas en el contorno.',
        },
        {
          p: '¿Qué cuidados necesito después?',
          r: 'No mojarlas las primeras 24 horas, cepillarlas a diario y evitar productos con aceite.',
        },
        {
          p: '¿Dañan mi pestaña natural?',
          r: 'No, si el grosor es adecuado y el retiro es profesional. Nunca las jales.',
        },
      ],
    },
    {
      id: 'volumen',
      nombre: 'Volumen ruso',
      duracion: '150 min',
      precio: '$900',
      etiqueta: 'Máxima densidad',
      resumen: 'Abanicos de varias extensiones ultrafinas por pestaña para una mirada densa y ligera.',
      descripcion:
        'En lugar de una extensión por pestaña se colocan abanicos hechos a mano con fibras mucho más finas. Suma densidad sin sumar peso. Es el servicio más largo del menú porque cada abanico se arma en el momento, y el que más cambia la mirada.',
      video: 'Armado de un abanico ruso a mano',
      beneficios: [
        'Densidad notable con peso mínimo',
        'Cubre huecos en pestañas escasas',
        'Efecto de delineado natural',
        'Duración pareja durante todo el ciclo',
      ],
      procedimiento: [
        'Limpieza profunda y mapeo del diseño',
        'Armado manual de abanicos según densidad deseada',
        'Aplicación aislando cada pestaña natural',
        'Revisión de simetría y sellado',
      ],
      ideal: 'Pestañas escasas, ojos que quieren mucho impacto, eventos y bodas.',
      fotos: ['Abanicos armados', 'Aplicación en proceso', 'Comparativa de densidad', 'Resultado final'],
      faq: [
        { p: '¿Cuánto dura la cita?', r: 'Entre dos horas y media y tres. Puedes dormir durante la sesión.' },
        {
          p: '¿Se sienten pesadas?',
          r: 'No. Las fibras son ultrafinas justo para que el peso total sea menor al de las clásicas gruesas.',
        },
        { p: '¿Cada cuánto se recomienda el relleno?', r: 'Cada 2 o 3 semanas.' },
        {
          p: '¿Qué cuidados necesito después?',
          r: 'Cepillado diario, nada de aceites y limpieza con espuma específica dos veces por semana.',
        },
      ],
    },
    {
      id: 'lifting',
      nombre: 'Lifting de pestañas',
      duracion: '60 min',
      precio: '$550',
      etiqueta: 'Sin extensiones',
      resumen: 'Curva permanente sobre tu propia pestaña, con tinte incluido.',
      descripcion:
        'Levanta y curva tu pestaña natural desde la raíz, con un tinte que la hace ver más larga y oscura. Sin extensiones y sin mantenimiento diario: dura de seis a ocho semanas y desaparece de forma gradual. Ideal si quieres el efecto pero no el compromiso del relleno.',
      video: 'Antes y después inmediato del lifting',
      beneficios: [
        'Mirada abierta sin extensiones',
        'Cero mantenimiento diario',
        'Dura de 6 a 8 semanas',
        'Incluye tinte para más profundidad',
      ],
      procedimiento: [
        'Limpieza y colocación del silicón según curvatura',
        'Aplicación de la loción de permanente',
        'Fijación y tinte',
        'Nutrición con keratina y revisión',
      ],
      ideal: 'Pestañas rectas o caídas, quien no quiere mantenimiento cada tres semanas.',
      fotos: ['Colocación de silicón', 'Proceso de tinte', 'Antes y después', 'Detalle de mirada'],
      faq: [
        { p: '¿Cuánto dura?', r: 'De 6 a 8 semanas, hasta que la pestaña se renueva sola.' },
        { p: '¿Puedo mojarme la cara después?', r: 'Espera 24 horas antes de mojar los ojos o usar maquillaje.' },
        { p: '¿Se puede repetir seguido?', r: 'Cada 8 semanas. Repetirlo antes puede resecar la pestaña.' },
        {
          p: '¿Sirve con pestañas muy cortas?',
          r: 'Sí, aunque el efecto es más sutil. Te lo decimos en la valoración.',
        },
      ],
    },
    {
      id: 'cejas',
      nombre: 'Diseño y laminado de cejas',
      duracion: '60 min',
      precio: '$500',
      etiqueta: 'Cejas',
      resumen: 'Diseño según tus facciones, laminado para fijar la forma y tinte opcional.',
      descripcion:
        'Medimos y diseñamos la ceja según la proporción de tu rostro antes de tocar un solo pelo. Después laminamos para peinar y fijar el vello en la dirección correcta, depilamos lo necesario y aplicamos tinte si hace falta densidad. El resultado se mantiene peinado por semanas.',
      video: 'Medición y diseño de la ceja antes de depilar',
      beneficios: [
        'Forma proporcional a tus facciones',
        'Vello peinado y fijo por semanas',
        'Rellena visualmente huecos',
        'Reduce el maquillaje diario de cejas',
      ],
      procedimiento: [
        'Medición y diseño con lápiz',
        'Laminado para fijar dirección del vello',
        'Depilación con pinza o cera',
        'Tinte opcional y nutrición final',
      ],
      ideal: 'Cejas rebeldes, con huecos o sin forma definida.',
      fotos: ['Medición y diseño', 'Laminado en proceso', 'Antes y después', 'Resultado peinado'],
      faq: [
        { p: '¿Cuánto dura el laminado?', r: 'De 4 a 6 semanas.' },
        { p: '¿Incluye tinte?', r: 'Sí, cuando el diseño lo requiere. Lo decidimos juntas en la valoración.' },
        {
          p: '¿Qué cuidados necesito después?',
          r: 'No mojar 24 horas y aplicar el aceite nutritivo que te damos cada noche la primera semana.',
        },
        {
          p: '¿Tiene contraindicaciones?',
          r: 'No se realiza sobre piel irritada, con dermatitis activa o tras un peeling reciente.',
        },
      ],
    },
  ],
};
